import { checkValidImgFormat } from '../../../utils/checkValidImgFormat';
import { Breakpoint, ResponsiveContentImage } from './ResponsiveImage';
import { memo } from 'react';

interface ResponsiveImageUrlProps {
    url: string;
    alt: string;
    className?: string;
    quality?: number;
    aspectRatio?: string;
    id?: string;
    imgWidth?: number;
    caption?: string;
}

export const ResponsiveImageUrlComponent = ({
    url,
    alt,
    className = '',
    quality = 60,
    aspectRatio = '16/9',
    id = null,
    imgWidth = 734,
    caption = '',
}: ResponsiveImageUrlProps) => {
    const breakpoints: Breakpoint[] = [
        {
            code: 'img',
            imgWidth: imgWidth,
            format: checkValidImgFormat(url),
            order: 100,
        },
        {
            code: 'xxs',
            cssMedia: '(min-width: 1px)',
            imgWidth: imgWidth,
            order: 99,
        },
        {
            code: 'md-webp',
            cssMedia: '(min-width: 992px)',
            imgWidth: imgWidth,
            format: checkValidImgFormat(url),
            order: 1,
        },
        {
            code: 'md',
            cssMedia: '(min-width: 992px)',
            imgWidth: imgWidth,
            order: 2,
        },
    ];

    return (
        <ResponsiveContentImage
            imgUrl={url}
            alt={alt}
            caption={caption || null}
            className={`img-fluid ${className}`}
            breakpoints={breakpoints}
            id={id}
            aspectRatio={aspectRatio}
            quality={quality}
        />
    );
};

const areResponsiveImagePropsEqual = (prevProps: ResponsiveImageUrlProps, nextProps: ResponsiveImageUrlProps) => {
    return Object.keys(prevProps).every(
        (key) => prevProps[key as keyof ResponsiveImageUrlProps] === nextProps[key as keyof ResponsiveImageUrlProps]
    );
};

export const ResponsiveImageUrl = memo(ResponsiveImageUrlComponent, areResponsiveImagePropsEqual);

export default ResponsiveImageUrl;
